import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RegisterPage from './RegisterPage';

/**
 * Trang "0. Cập nhật thông tin" (route /cap-nhat-thong-tin), vào từ menu góc phải.
 * Dùng lại form RegisterPage ở chế độ update — nhận accessToken từ AuthWrapper (cloneElement).
 */
const UpdateProfilePage = ({ accessToken }) => {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  return (
    <RegisterPage
      mode="update"
      accessToken={accessToken}
      onBackToLogin={() => navigate('/dashboard')}
      onDone={() => navigate('/dashboard')}
      error={error}
      setError={setError}
      loading={loading}
      setLoading={setLoading}
    />
  );
};

export default UpdateProfilePage;
